"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZipSlidesState = void 0;
var ZipSlidesState;
(function (ZipSlidesState) {
    ZipSlidesState["GeneratingSlidesZip"] = "generatingSlidesZip";
    ZipSlidesState["DeletingSlidesZip"] = "deletingSlidesZip";
})(ZipSlidesState = exports.ZipSlidesState || (exports.ZipSlidesState = {}));
//# sourceMappingURL=zip-slides-state.js.map